<template>
  <div class="bs-station">
    <h2>{{ station.name }}</h2>
    <p class="num-bikes">🚲 Ledige sykler: {{ station.num_bikes_available }}</p>
    <p class="num-docks">🔒 Ledige låser: {{ station.num_docks_available }}</p>
  </div>
</template>

<script>
export default {
  name: 'BSStation',
  props: {
    station: Object,
  },
}
</script>

<style lang="scss">
.bs-station {
  p {
    margin: 0;
    line-height: 2em;
  }
}
</style>
